import React, { useEffect, useMemo, useRef, useState, useCallback } from 'react';
import { FaQuestionCircle } from 'react-icons/fa';
import './PrintHelpDialog.css';

/** Small popup that explains Original vs Moved/Consolidated */
export default function PrintHelpDialog() {
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <button
        type="button"
        className="icon-btn"
        onClick={() => setOpen(true)}
        title="What is Original vs Moved Inventory?"
        style={{ marginLeft: 8 }}
      >
        <FaQuestionCircle size={16} style={{ color: '#888' }} />
      </button>

      {open && (
        <div className="modal-printhelp-backdrop" onClick={() => setOpen(false)}>
          <div
            className="modal-printhelp"
            role="dialog"
            aria-modal="true"
            aria-labelledby="helpTitle"
            onClick={(e) => e.stopPropagation()}
            style={{ maxWidth: 520 }}
          >
            <div className="modal-printhelp-header">
              <h3 id="helpTitle">Original vs Moved/Consolidated Inventory</h3>
              <button className="icon-btn" onClick={() => setOpen(false)} aria-label="Close">×</button>
            </div>
            <div className="modal-printhelp-body">
              <p>
                <b>Original Inventory</b> = Items first received on this receipt..
              </p>
              <p>
                <b>Moved / Consolidated</b> = Items later transferred into this receipt/pallet
                from somewhere else.
              </p>
              <p>When printing, choose:</p>
              <ul>
                <li><b>Original only</b> – show only initial received rows.</li>
                <li><b>Include moved/consolidated</b> – show everything on the receipt.</li>
              </ul>
            </div>
            <div className="modal-printhelp-footer">
              <button className="btn primary" onClick={() => setOpen(false)}>Got it</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}